module.exports = __webpack_public_path__ + "static/media/baichang.27bdd751.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/baichang.png
 ** module id = 433
 ** module chunks = 0
 **/